import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(columnsStyles, {
    container: {
        gap: 20,
        css: css`
            margin-bottom: 82px;
            margin-top: 46px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0;
                    `,
                    null,
                    css`
                        margin-top: 0;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 3, 3],
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 9, 9],
    },
});
